import {
    Tournament,
    TournamentPlayerStatus,
    TournamentRound,
    TournamentStatus,
} from '@types';

export const roundIsOngoing = (round: TournamentRound) => {
    return (
        new Date(round.startedAt).getTime() < new Date().getTime() &&
        round.endedAt === null
    );
};

export const tournamentIsRunning = (tournament: Tournament) => {
    return tournament.status === TournamentStatus.Running;
};

export const tournamentIsFinished = (tournament: Tournament) => {
    return (
        tournament.status === TournamentStatus.Finished ||
        tournament.status === TournamentStatus.Cancelled
    );
};

export const tournamentIsCanncelled = (tournament: Tournament) => {
    return tournament.status === TournamentStatus.Cancelled;
};

export const tournamentIsScheduled = (tournament: Tournament) => {
    return tournament.status === TournamentStatus.Scheduled;
};

// The server's status determines the stage; reaching the scheduled time alone
// does not mean the first round is ready to play.
export const getTournamentPath = (
    tournament: Pick<Tournament, 'id' | 'status' | 'currentRound'>,
    viewerId?: number
) => {
    if (tournament.status === TournamentStatus.Scheduled) {
        return `/tournaments/${tournament.id}/lobby`;
    }
    const activePlayer = tournament.currentRound?.results.some(
        ({player}) =>
            player.user.id === viewerId &&
            player.status === TournamentPlayerStatus.Active
    );
    if (tournament.status === TournamentStatus.Running && activePlayer) {
        return `/tournaments/${tournament.id}/play`;
    }
    return `/tournaments/${tournament.id}/results`;
};
